"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectLauScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@pasport/react-ui");
const react_1 = require("react");
const useAuth_1 = require("../hooks/useAuth");
const react_router_dom_1 = require("react-router-dom");
const SelectLauScreen = ({ redirect = true }) => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const backUrl = params.get('back');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { activeLau, setActiveLau } = (0, useAuth_1.useAuth)();
    const [selectedLau, setSelectedLau] = (0, react_1.useState)(activeLau);
    const { user } = (0, useAuth_1.useAuth)();
    const lauList = user?.lauList ?? [];
    (0, react_1.useEffect)(() => {
        if (!redirect && lauList.length === 1) {
            setLauAsActive(lauList[0]);
        }
    }, [user]);
    const setLauAsActive = (lauId) => {
        setActiveLau(lauId ? lauId : undefined);
    };
    const handleSelectConfirm = () => {
        setLauAsActive(selectedLau);
        if (redirect) {
            if (backUrl)
                window.location.href = backUrl;
            else
                navigate("/");
        }
    };
    if (lauList.length === 0)
        return (0, jsx_runtime_1.jsx)(react_ui_1.CenterView, { children: "..." });
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-center h-100 d-flex align-items-center justify-content-center", children: (0, jsx_runtime_1.jsx)("div", { style: { maxWidth: 500, width: '100%' }, children: (0, jsx_runtime_1.jsx)(react_ui_1.Card, { children: (0, jsx_runtime_1.jsxs)(react_ui_1.CardBody, { children: [(0, jsx_runtime_1.jsx)(react_ui_1.CardHeader, { glueBottom: true, children: activeLau ? "Změnit aktivní obec" : "Vyberte obec" }), (0, jsx_runtime_1.jsx)(react_ui_1.CardSection, { glueBottom: true, children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex flex-column gap-2", children: lauList.map(item => ((0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: "dark", variant: "outlined", fullWidth: true, onPress: () => setSelectedLau(item), active: item.id === selectedLau?.id, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex gap-3 align-items-center p-2", children: [(0, jsx_runtime_1.jsx)("i", { className: "bi bi-geo-alt-fill" }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsxs)("span", { children: [item.obec, " ", (0, jsx_runtime_1.jsxs)("span", { className: "fw-normal", children: [" (", item.okres, ")"] })] }) }), (0, jsx_runtime_1.jsx)("small", { className: "flex-grow-1 text-end fw-light", children: (0, jsx_runtime_1.jsx)("strong", { children: item.id }) })] }) }, item.id))) }) }), (0, jsx_runtime_1.jsx)(react_ui_1.CardSection, { children: (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-end", children: (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: "success", onPress: handleSelectConfirm, children: "Zvolit" }) }) })] }) }) }) }));
};
exports.SelectLauScreen = SelectLauScreen;
